import React from 'react';

export default function PrivacyPolicy({ navigate }) {
  return (
    <>
      <h2 className="page-title">🔒 Política de Privacidad</h2>

      <div className="card">
        <p style={{ fontSize: '0.8rem', color: 'var(--text-sub)', marginBottom: 16 }}>
          Última actualización: Junio 2026
        </p>

        <h3 style={{ marginBottom: 8 }}>Información que Recopilamos</h3>
        <p style={{ fontSize: '0.88rem', lineHeight: 1.7, color: 'var(--text-sub)', marginBottom: 16 }}>
          Cuando realizas una donación, recopilamos tu nombre, correo electrónico e información de pago procesada de forma segura a través de Stripe y MinistryForms. Cuando envías una petición de oración, recopilamos el contenido de tu petición y, opcionalmente, tu nombre y correo electrónico.
        </p>

        <h3 style={{ marginBottom: 8 }}>Cómo Usamos tu Información</h3>
        <p style={{ fontSize: '0.88rem', lineHeight: 1.7, color: 'var(--text-sub)', marginBottom: 16 }}>
          Usamos tu información únicamente para procesar donaciones, enviarte recibos de donación, y responder a tus peticiones de oración. No vendemos ni compartimos tu información personal con terceros con fines comerciales.
        </p>

        <h3 style={{ marginBottom: 8 }}>Pagos y Seguridad</h3>
        <p style={{ fontSize: '0.88rem', lineHeight: 1.7, color: 'var(--text-sub)', marginBottom: 16 }}>
          Todos los pagos son procesados de forma segura a través de Stripe y MinistryForms con cifrado de 256 bits. Bethesda Español nunca almacena los datos de tu tarjeta de crédito o débito.
        </p>

        <h3 style={{ marginBottom: 8 }}>Notificaciones Push</h3>
        <p style={{ fontSize: '0.88rem', lineHeight: 1.7, color: 'var(--text-sub)', marginBottom: 16 }}>
          Si activas las notificaciones, usamos Firebase Cloud Messaging para enviarte avisos sobre servicios y eventos. Puedes desactivarlas en cualquier momento desde la configuración de tu dispositivo.
        </p>

        <h3 style={{ marginBottom: 8 }}>Inicio de Sesión con Google</h3>
        <p style={{ fontSize: '0.88rem', lineHeight: 1.7, color: 'var(--text-sub)', marginBottom: 16 }}>
          Si inicias sesión con Google, recopilamos tu nombre y correo electrónico de tu perfil de Google únicamente para personalizar tu experiencia dentro de la app.
        </p>

        <h3 style={{ marginBottom: 8 }}>Tus Derechos</h3>
        <p style={{ fontSize: '0.88rem', lineHeight: 1.7, color: 'var(--text-sub)', marginBottom: 16 }}>
          Tienes derecho a solicitar la eliminación de tu información personal en cualquier momento. Para hacerlo, contáctanos al correo electrónico indicado abajo.
        </p>

        <h3 style={{ marginBottom: 8 }}>Contáctanos</h3>
        <p style={{ fontSize: '0.88rem', lineHeight: 1.7, color: 'var(--text-sub)' }}>
          Si tienes preguntas sobre esta política de privacidad, puedes contactarnos en:{' '}
          <a href="tel:8179957398" style={{ color: 'var(--navy)', fontWeight: 600 }}>(817) 995-7398</a>
          {' '}o visitar{' '}
          <a href="https://bethesdacommunitychurch.com/home-2/" target="_blank" rel="noreferrer" style={{ color: 'var(--navy)', fontWeight: 600 }}>bethesdacommunitychurch.com</a>
        </p>
      </div>

      <div className="card" style={{ textAlign: 'center' }}>
        <p style={{ fontSize: '0.82rem', color: 'var(--text-sub)', lineHeight: 1.6 }}>
          Bethesda Español es un ministerio de{' '}
          <strong>Bethesda Community Church</strong>, una organización sin fines de lucro 501(c)(3).
          {' '}4700 N Beach St, Fort Worth, TX.
        </p>
      </div>

      <button
        onClick={() => navigate && navigate('back')}
        style={{
          width: '100%', padding: '13px',
          border: '1.5px solid var(--border)', borderRadius: 10,
          background: 'white', color: 'var(--navy)',
          fontSize: '0.95rem', fontWeight: 700,
          cursor: 'pointer', fontFamily: 'Inter, sans-serif',
          marginBottom: 16,
        }}
      >
        ← Regresar
      </button>
    </>
  );
}
